var map = {
	"./Apex-logo.svg": "757f",
	"./LiSA-logo.svg": "0243",
	"./LoT-logo.svg": "ffae",
	"./WL-logo.svg": "fce6",
	"./placeholder-logo.svg": "71a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4980";